import moment from "moment";
import authGraphQLRequest from "utils/authGraphQLRequest";

export const getCardType = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `{
  cardTypes
}   `;
    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_card_type'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getPaymentsFilter = (
  page: number,
  // curretClient: string,
  pageSize: number = 50,
  type?: string,
  client?: any,
  gateway?: any,
  card_type?: any,
  payment_status?: any,
  timezone?: any,
  start_date?: any,
  searchTexts?: string,
  end_date?: any,

): Promise<any> => {

  return new Promise((resolve, reject) => {
    let is_live = type === "live" ? true : type === "test" ? false : "all"
    let client_ids = client?.length > 0 ? client : ""
    let queryString = `
    {
      paymentFilterSearch(
        page: ${page}, 
        per_page: ${pageSize}, 
        is_live: "${is_live}"
        ${client_ids ? `, client_ids: "${client_ids}"` : ""}
        ${searchTexts ? `, search_term: "${searchTexts}"` : ""}
        ${payment_status?.length > 0 ? `, status: "${payment_status}"` : ""}
        ${start_date ? `, start_date: "${moment(start_date).format("YYYY-MM-DD")}"` : ""}
        ${end_date ? `, end_date: "${moment(end_date).format("YYYY-MM-DD")}"` : ""}
        ${gateway?.length > 0 ? `, gateway_id: "${gateway}"` : ""}
        ${card_type?.length > 0 ? `, card_type: "${card_type}"` : ""}
        ${timezone ? `, timezone: "${timezone}"` : ""}
        ) {
        payments {
          id
          payment_id
          client_is_deleted
          clientId
          et_id
          reference_id
          amount
          currency
          converted_currency
          converted_amount
          status
          gateway_id
          meta_info
          gateway_response
          payment_type
          refund_info
          payment_history
          created_at
          client
          receipt_url
          card_type
          gateway_name
          customer_name
        }
      }
    }
    `;
    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_payment_filter_search'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });

}

export const changePaymentStatus = (data: any, internal_id: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `
    
mutation {
  changePaymentStatus(
    internal_id: "${internal_id}"
    input: {
      arn_number: "${data.arn_number}"
      reason: "${data.reason}"
      current_status: "${data.current_status}"
      change_status_date: "${data.change_status_date}"
      transaction_id : "${data.transaction_id}"
      auth_id : "${data.auth_id}"
    }
  ) {
    status
    message
  }
}

    `;
    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_update_status'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getStatusHistory = (data: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `
    
{
  paymentHistory(internalId: "${data.id}") {
    previous_status
    status
    created_at
    status_changed_date
    client
    gateway_name
    ip
    arn
    reason
    user_id
    first_name
    last_name
  }
}
    `;
    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_payment_history'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

